import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateService {

    constructor(
        private http: CustomHttpService
    ) { }

    getAllEmailTemplate(body: any): Observable<any> {
        return this.http.post(environment.getAllEmailTemplate, body);
    }

    createTemplate(data: any): Observable<any> {
        return this.http.post(environment.createEmailTemplate, data);
    }

    updateTemplate(data: any): Observable<any> {
        return this.http.post(environment.updateEmailTemplate, data);
    }

    deleteTemplate(data: any): Observable<any> {
        return this.http.post(environment.deleteEmailTemplate, data);
    }

    uploadFileToS3(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folders', 'public/educationcrm/');
        formData.append('bucket', 'global-upload-storage');
        return this.http.post(environment.uploadFileToS3, formData);
    }

}